module.exports = "<i class=\"fa\" ng-class=\"{'fa-car': isPA, 'fa-home': isHomeowners }\"></i>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/integration/endorsement/directives/templates/endorsement-policy-icon.html
// module id = 1093
// module chunks = 0